import { Box, Tooltip } from '@material-ui/core';
import { Help } from '@material-ui/icons';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { Document } from '@roc/feature-types';
import { StandardDialog, Button } from '@roc/ui';
import { ManualTaskForm } from './manualTasksForm';
import { useDocumentStore } from "@roc/feature-documents";
import { observer } from 'mobx-react';

export type ResolutionItemProps = {
  open?: boolean;
  onClose?: () => void;
  loanTaskId?: number;
  document?: Document;
};

export const ManualTasksItem = observer((
  props: ResolutionItemProps
) => {
  const { open, onClose, loanTaskId, document } = props;
  const taskId = document?.taskId;
  const { documentStore } = useDocumentStore();
  const getTitle = () => {
    return (
      <div>
        {document?.taskName}
        <Tooltip
          placement="right"
          title={<p style={{ fontSize: '12px' }}> {document?.taskName} </p>}
        >
          <Help color="primary" style={{ fontSize: '18px', marginLeft: '3px', marginBottom: '10px' }} />
        </Tooltip>
      </div>
    );
  }

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title={document?.taskName}
          handleClose={onClose}
          dialogContent={
            <ManualTaskForm store={documentStore} handleClose={onClose} resetOnUnmount={false} />}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title={getTitle()}
          maxWidth="sm"
          handleClose={onClose}
          dialogContent={<div style={{ marginTop: '-40px' }}><ManualTaskForm store={documentStore} handleClose={onClose} /></div>}
        />
      )}
    </>
  );
});

export default ManualTasksItem;
